import { Pages } from '../../../../Enums';
import { EditStatus, ProductEntry, StoreOrder } from '../../../../SharedTypes/Models';

export const Status = (page: Pages, entries: ProductEntry[]): EditStatus => {
	if (page === Pages.ORDERS_PAGE) {
		const amountAltered = entries.filter(
			(entry) => entry.templateValue !== entry.ordered
		);

		return amountAltered.length > 0 ? 'reported' : 'none';
	}
	if (page === Pages.WASTE_PAGE) {
		const amountReported: ProductEntry[] = entries.filter(
			(entry) => entry.isReported
		);

		if (entries.length !== 0 && amountReported.length === entries.length) {
			return 'reported';
		}

		if (amountReported.length > 0) {
			return 'partial';
		}

		return 'none';
	}
	if (page === Pages.PRODUCTION_PAGE) {
		//TODO: add handle for production in another branch.
		return 'none';
	}
	return 'none';
};


export const StoreOrderStatus = (page: Pages, date: string, storeOrders: StoreOrder[]): EditStatus => {
	if (page === Pages.ORDERBOOK_STORE_PAGE) {

        const found = storeOrders.find(element => element && element.pickupTime === date);

		if(found){
			return 'reported';
		}
	}

	return 'none';
};


export const ProductionOrderStatus = (page: Pages, date: string, storeOrders: StoreOrder[]): EditStatus => {
	if (page === Pages.ORDERBOOK_PRODUCTION_PAGE) {

        const found = storeOrders.find(element => element && element.pickupTime === date);

		if(found){
			return 'reported';
		}
	}

	return 'none';
};